import {
  AssignmentRecordStudentsDownloadOutput,
  DownloadAssignmentRecordStudentsRequest,
  GetAssignmentRecordRequest,
  GetAssignmentRecordResponse,
  GetAssignmentsListRequest,
  GetAssignmentsListResponse,
  OrgRefScope
} from "../../../../types/gqlTypes/graphql"
import { executeQuerySideload } from "../../helpers/studyPlan"
import {
  DOWNLOAD_ASSIGNMENT_RECORD_STUDENTS,
  GET_ASSIGNMENT_RECORD,
  GET_ASSIGNMENTS
} from "./assignmentsQueries"

export const getAssignments = async (
  data: GetAssignmentsListRequest
): Promise<GetAssignmentsListResponse> => {
  const response = await executeQuerySideload(GET_ASSIGNMENTS, { data })
  return response?.assignments?.getList
}

export const getAssignmentById = async (
  id: string,
  orgRefScope: OrgRefScope
): Promise<GetAssignmentsListResponse> => {
  const data: GetAssignmentsListRequest = {
    orgRefScope,
    ids: [id]
  }
  const response = await executeQuerySideload(GET_ASSIGNMENTS, { data })
  return response?.assignments?.getList
}

export const getAssignmentRecord = async (
  data: GetAssignmentRecordRequest
): Promise<GetAssignmentRecordResponse> => {
  const response = await executeQuerySideload(GET_ASSIGNMENT_RECORD, { data })
  return response?.assignments?.getRecord
}

export const downloadAssignmentRecordStudents = async (
  data: DownloadAssignmentRecordStudentsRequest
): Promise<AssignmentRecordStudentsDownloadOutput> => {
  const response = await executeQuerySideload(
    DOWNLOAD_ASSIGNMENT_RECORD_STUDENTS,
    { data }
  )
  return response?.assignments?.downloadRecordStudents
}
